// @ts-check

angular.module('checkout').controller(
    'distKitsSelect',
    [
        'orderMgr',
        'rcmLoading',
        '$location',
        'rcmApiLibMessageService',
        'rcmApiLibService',
        '$sce',
        'rcmEventManager',
        /** @type {import('angular').IControllerConstructor} */ (function (
            /** @type {import('cart-core').CartOrderManager} */ orderMgr,
            rcmLoading,
            $location,
            rcmApiLibMessageService,
            rcmApiLibService,
            $sce,
            rcmEventManager
        ) {
            let self = this;

            self.order = null;
            self.category = '';
            self.hasMessage = false;

            self.hideContent = orderMgr.executeCurrentPageRequirements();
            //
            self.products = [];
            self.loading = true;
            self.selected = {
                checked: null,
            };

            self.select = function (sku) {
                self.selected.checked = false;
                sku.checked = true;
                self.selected = sku;
            };

            let namespace = 'checkoutDistKitSelect';

            /**
             * @todo 2021-04-23 - bharms@relivinc.com - axosoft/25604:
             * No analytics tracking is currently performed by this function.
             * Add support for server-side tracking when the function is
             * called. It will need to be able to identify the source of the
             * event to the server from here, although the actual event will
             * not be fired from here.
             */
            self.submit = function () {
                orderMgr.setItems(
                    [
                        {
                            skuNumber: self.selected.number,
                            qty: 1,
                            type: 'enrollment',
                        },
                    ],
                ).then(() => void orderMgr.nextPage());
            };

            /**
             * prepareData
             * @param data
             * @returns {Array}
             */
            let prepareData = function (data) {
                self.products = [];
                angular.forEach(
                    data, function (product) {
                        angular.forEach(
                            product.skus, function (sku) {
                                sku.image = '';
                                if (sku.images[0]) {
                                    //display image
                                    sku.image = sku.images[0].imageSrc;
                                }
                                //display sku description
                                sku.description = $sce.trustAsHtml(sku.description);

                                let skuQuantity = orderMgr.getSkuQty(sku.number);

                                if (skuQuantity == 1) {
                                    return self.select(sku);
                                }
                            }
                        );
                        self.products.push(product);
                    }
                );
                return (self.products);
            };

            /**
             * getProductsInCategory
             * @param category
             */
            let getProductsInCategory = function (category) {
                self.hasMessage = false;
                rcmApiLibService.get(
                    {
                        url: '/api/app/products-in-category/' + category,
                        loading: function (loading) {
                            self.loading = loading;
                            let loadingInt = Number(!loading);
                            rcmLoading.setLoading(
                                namespace,
                                loadingInt
                            );
                        },
                        success: function (data) {
                            if (data.data.length < 1) {
                                let message = new rcmApiLibService.ApiMessage(
                                    rcmApiLibService.config.defaultMessage
                                );
                                message.primary = true;
                                rcmApiLibMessageService.setPrimaryMessage([message], namespace);
                                // hide stuf like it is loading
                                self.loading = true;
                                self.hasMessage = true;
                                return;
                            }
                            prepareData(data.data);
                        },
                        error: function (data) {
                            self.hasMessage = true;
                            rcmApiLibMessageService.buildPrimaryMessage(data.messages, namespace);
                        },
                    }
                );
            };

            /**
             * onGetCurrentOrderSuccess
             * @param response
             */
            self.onGetCurrentOrderSuccess = function (response) {
                self.onOrderChange(response.data);
            };

            /**
             * onOrderChange
             * @param {import('cart-core').CartOrder} order
             */
            self.onOrderChange = function (order) {
                self.order = order;
                self.category = self.order.attributes.enrollmentRules.selectEnrollmentSkusCategoryForNewProfile;
                getProductsInCategory(self.category);
            };

            /**
             * on orderMgr.orderChange
             */
            rcmEventManager.on(
                'orderMgr.orderChange',
                self.onOrderChange,
                'distkitselect'
            );

            /**
             * init
             */
            let init = function () {
                orderMgr.getCurrentOrder(
                    self.onGetCurrentOrderSuccess
                );
            };

            init();
        }),
    ]
);
